/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Bulk_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} project(s)? This will permanently delete their chats and cannot be undone." |
*
* @param {Projects_Bulk_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_delete_confirm_description = /** @type {((inputs: Projects_Bulk_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie wirklich ${i?.count} Projekt(e) löschen? Die zugehörigen Chats werden ebenfalls dauerhaft gelöscht.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} project(s)? This will permanently delete their chats and cannot be undone.`)
});